import { useEffect, useState } from 'react';

function useInputType() {
    const [inputType, setInputType] = useState<'mouse' | 'touch'>('mouse');

    useEffect(() => {
        const handleMouseMove = () => setInputType('mouse');
        const handleTouchStart = () => setInputType('touch');

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('touchstart', handleTouchStart);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('touchstart', handleTouchStart);
        };
    }, []);

    return inputType;
}

export default useInputType;
